import React from "react";
import ReactPaginate from "react-paginate";
import "bootstrap/dist/css/bootstrap.min.css";
import Usernav from "./Usernav";
import Sellernav from "./Sellernav";
import Adminnav from "./Adminnav";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import Cards from "./Cards";
import "./Homepage.css";
import "./Cards.css";
import BaseURL from "../Util/BaseURL";

let data = "";
const Homepage = () => {
  var nav = useNavigate();
  const [role, setRole] = useState("");
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("pic");
  const [pageNumber, setPageNumber] = useState(0);
  const productsPerPage = 6;
  const pagesVisited = pageNumber * productsPerPage;
  const [pageCount, setPageCount] = useState();
  const [search,setSeach]=useState("")
  const changePage = ({ selected }) => {
    document.getElementById('prods').scrollIntoView();
    setPageNumber(selected);
  };

  const init = async () => {
    const r = await axios.get(
      `${BaseURL}FindByName?name=${sessionStorage.getItem("user")}`
    );
    data = r.data[0].role[0].roleName;
    setRole(data);
    sessionStorage.setItem("c", data);
  };
  init();
  const [products, setProducts] = useState([]);
  const getProducts = async () => {
    const response = await axios.get(
      `${BaseURL}getAllProducts?size=${productsPerPage}&startPage=${pageNumber}`
    );
    setPageCount(Math.ceil(response.data.totalPages));
    setProducts(response.data.content);
  };
  useEffect(() => {
    getProducts();
  }, [pageNumber]);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
       nav('/SearchResults', { state: { search: search} })
    }
  }
  return (
    <>
      {sessionStorage.getItem("c") === "User" ? (
        <Usernav />
      ) : sessionStorage.getItem("c") === "Seller" ? (
        <Sellernav />
      ) : sessionStorage.getItem("c") === "Admin" ? (
        <Adminnav />
      ) : (
        <Usernav />
      )}
      <div className='d-block d-lg-none d-xl-none'>
            <input id='search' className="searchUser" type="text" placeholder="Search for products, brand and more" name="search" value={search} 
            onChange={(e)=>setSeach(e.target.value)} onKeyDown={handleKeyDown}/>
      </div>
      <div
        id="demo"
        className="carousel slide d-none d-xl-block d-md-block d-lg-block"
        data-ride="carousel"
      >
        <ul className="carousel-indicators">
          <li data-target="#demo" data-slide-to="0" className="active"></li>
          <li data-target="#demo" data-slide-to="1"></li>
          <li data-target="#demo" data-slide-to="2"></li>
        </ul>
        <div className="carousel-inner">
          <div className="carousel-item active">
            <img src="https://pukassurf.com/wp-content/uploads/sites/3/sites/3/2018/10/Pukas-surf-clothing-banner.jpg" />
          </div>
          <div className="carousel-item">
            <img src="https://chetmani.com/wp-content/uploads/2021/12/Home-Pgae_Top-Banner1.jpg" />
          </div>
          <div className="carousel-item">
            <img src="https://assets.dragonmart.ae//pictures/0103296_DragonMart_categorylisting_computer&electronics_1of3.jpeg" />
          </div>
        </div>
        <div className="button my-5">
          <a className="carousel-control-prev" href="#demo" data-slide="prev">
            <span className="carousel-control-prev-icon"></span>
          </a>
          <a className="carousel-control-next" href="#demo" data-slide="next">
            <span className="carousel-control-next-icon"></span>
          </a>
        </div>
      </div>
      <div>
        <div className="container row mx-auto" id="prods">
          {products ? products.map((data,key) => <Cards key={key} data={data} />) : ""}
        </div>
      </div>

      <div className="my-5 totalpagebtn mx-auto d-none d-xl-block">
        <ReactPaginate
          previousLabel={<i className="fas fa-angle-double-left"></i>}
          nextLabel={<i className="fas fa-angle-double-right"></i>}
          pageCount={pageCount}
          onPageChange={changePage}
          containerClassName={"paginationBttns"}
          previousLinkClassName={"previousBttn"}
          nextLinkClassName={"nextBttn"}
          disabledClassName={"paginationDisabled"}
          activeClassName={"paginationActive"}
        />
      </div>
      <div className="totalpagebtnsm mx-auto d-block d-lg-none d-xl-none">
        <ReactPaginate
          previousLabel={<i className="fas fa-angle-double-left"></i>}
          nextLabel={<i className="fas fa-angle-double-right"></i>}
          pageCount={pageCount}
          onPageChange={changePage}
          containerClassName={"paginationBttns "}
          previousLinkClassName={"previousBttn"}
          nextLinkClassName={"nextBttn"}
          disabledClassName={"paginationDisabled"}
          activeClassName={"paginationActive"}
        />
      </div>
    </>
  );
};

export default Homepage;
